import React, { Component } from 'react';

import VideoPlayer from '../../../../components/VideoPlayer';

class VideoCard extends Component {
  static styles = {};

  videoEndedEvent = () => {
    if (this.props.switchToNextCardOnVideoEnd) {
      this.props.videoEndedEvent && this.props.videoEndedEvent();
    }
  };

  render() {
    const styles = VideoCard.styles;
    return (
      <div
        style={styles.videoWrapper}
        className="VideoCardContainer"
        id="_videoCardVideoContainer_"
      >
        <VideoPlayer
          ref="videoJsPlayerRef"
          useEventsHelper={false}
          videoUrl={this.props.card.url}
          thumbUrl={this.props.card.thumbUrl}
          onEndEvent={this.videoEndedEvent}
          autoPlay={true}
          azureVideoOptions={{ autoplay: true }}
        />
      </div>
    );
  }
}

VideoCard.styles = {
  videoWrapper: {
    position: 'relative',
    paddingBottom: '56.25%'
  }
};

export default VideoCard;
